export default "__VITE_ASSET__DHw24so$__"